import React from 'react';
import { Reveal } from './ui/Reveal';
import { proofStats } from '../data/content';
export function SocialProof() {
  return <section aria-label="Todo lo que necesitás en un solo lugar" className="border-b border-line bg-accent" data-id="element-232" data-mp="3ltm57xko2z6u">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-6" data-id="element-233" data-mp="36xog2z95uv44">
        <p className="text-center text-xs font-bold uppercase tracking-[0.24em] text-white/75" data-id="element-234" data-mp="3bvg77r1zed79">
          Todo lo que necesitás para empezar a volver a ti. En un solo lugar.
        </p>
        <dl className="mt-4 grid grid-cols-2 gap-x-6 gap-y-5 text-center md:grid-cols-4 md:divide-x md:divide-white/20" data-id="element-235" data-mp="8cwll7dt65lf">
          {proofStats.map((stat, i) => <Reveal key={stat.label} delay={i * 0.03} className="md:px-6" data-id="element-236" data-mp="3utixe969mg6n" data-mpi={i}>
              <dt className="font-display text-3xl md:text-4xl font-bold text-white" data-id="element-237" data-mp="3urfyezn4xcps">
                {stat.value}
              </dt>
              <dd className="mt-1 text-sm font-semibold text-white/85" data-id="element-238" data-mp="r4z7ax5b4c2j">
                {stat.label}
              </dd>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}